import { Action } from "@ngrx/store/src/models";
import { ExtractModel } from "../../models/ExtractModel";

export const GET_EXTRACT_CATEGORY_QUERY_SUCCESS = "[Extract] Get Extract Category Query Success";

export class GetExtractCategoryQuerySuccessAction implements Action {
  readonly type: string;

  constructor(public payload: { items: ExtractModel[] }) {
    this.type = GET_EXTRACT_CATEGORY_QUERY_SUCCESS;
  }
}



// WEBPACK FOOTER //
// ./src/app/extracts/store/actions/GetExtractCategoryQuerySuccessAction.ts